'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_env_isBrowserEnv_isBrowserEnv = require('../../env/isBrowserEnv/isBrowserEnv.js');
var utils_env_isProdEnv_isProdEnv = require('../../env/isProdEnv/isProdEnv.js');
require('../../env/isTestEnv/isTestEnv.js');

var loggedMessages = new Set();
function logDeprecatedFeature(message) {
  if (!utils_env_isBrowserEnv_isBrowserEnv.isBrowserEnv) return undefined;
  if (utils_env_isProdEnv_isProdEnv.isProdEnv) return undefined;
  var logMessage = "[NuDS/Deprecated] ".concat(message);

  if (!loggedMessages.has(logMessage)) {
    console.warn(logMessage);
    loggedMessages.add(logMessage);
  }

  return undefined;
}

exports.logDeprecatedFeature = logDeprecatedFeature;
//# sourceMappingURL=logDeprecatedFeature.js.map
